import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { Form } from "react-bootstrap";
import { toast } from "react-toastify";
import {
  getUserProfileById,
  updateUserProfile,
  updateUserProfileImage,
} from "../../services/UserProfileService";
import { getStateList } from "../../services/StateService";
import { getCountryList } from "../../services/CountryService";
import { UserProfileModel } from "../../components/Model/userProfileModel";
import { CommonModal } from "../../shared/commonModal";
import Modal from "../../components/Modal/Modal";
import ImageUpload from "../../components/Image/ImageUpload";
import { AuthService } from "../../services";
import Avatar from "../../components/Image/AvatarPreview";
import { globalConstant } from "../../constants/globalConstant";
import { formatDateENGB, handleConsoleError } from "../../utils/common-methods";
import { getLoginUser, setLoginUser } from "../../services/AuthService";
import { Link } from "react-router-dom";
import { routes } from "../../constants/routes";
import { injectModels } from "../../redux/injectModels";
import UpdateEmail from "./UpdateEmail";

const PersonalInfo = (props) => {
  const [stateList, setStateList] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [selectedCountryId, setSelectedCountryId] = useState("");
  const [selectedStateId, setSelectedStateId] = useState("");
  const [userData, setUserData] = useState({ ...UserProfileModel });
  const [showModal, setShowModal] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const openModal = () => setModalOpen(true);
  const closeModal = () => setModalOpen(false);


    const [showEmailModal, setShowEmailModal] = useState(false);
  const [isModalEmailOpen, setModalEmailOpen] = useState(false);
    const openEmailModal = () => setModalEmailOpen(true);
   const closeEmailModal = () => setModalEmailOpen(false);
  const loginUser = AuthService.getLoginUser();
  const [isCountrySelected, setIsCountrySelected] = useState(false);
  const [previewImageURL, setPreviewImageURL] = useState("");
  const [submitHandler, setSubmitHandler] = useState(null);
 
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm();


  const handleImageUpload = async (file) => {
    const formData = new FormData();
    formData.append("Image", file.get("image")); // Field name must match the property in C# model
    formData.append("Id", loginUser?.id); // Optional field
    try {
      const response = await updateUserProfileImage(formData);
      if (response?.isSuccess) {
        closeModal();
        toast.success(response?.message);
        const authUser = getLoginUser();
        const updatedUser = {
          id: authUser?.id,
          firstName: authUser?.firstName,
          lastName: authUser?.lastName,
          email: authUser?.email,
          role: authUser?.role,
          profileUrl: response?.data?.completeURL,
        };
        setLoginUser(updatedUser);
        window.location.reload();
      }
    } catch (error) {
     const message= handleConsoleError(error);
      toast.error(error?.message|| message);
    }
  };

   const onEmailChangeSubmit = async () => {   
    submitHandler?.();
   }
   const onEmailChangeSuccess= async()=>
   {
     setShowEmailModal(false);
   }

  const onSubmit = async (data) => {
    console.log(data);
    // if (!selectedCountryId) {
    //   toast.error("Please select a country.");
    //   return;
    // }
    if (!data.countryId) {
      data.countryId = null;
    }
    if (!data.birthday) {
      data.birthday = null;
    }
   
    try {
      data.userId = loginUser?.id;
      if (data.countryId === "") {
        data.countryId = null;
      }
      if (data.stateId === "") {
        data.stateId = null;
      }
      data.phone = data.phone === "" ? null : data.phone;
      const response = await updateUserProfile(data);
      if (response?.isSuccess) {
        setShowModal(false);
        toast.success(response?.message);
        getUserProfile();
        const authUser = getLoginUser();
        const updatedUser = {
          id: authUser?.id,
          firstName: response?.data?.firstName,
          lastName: response?.data?.lastName,
          email: response?.data?.email,
          role: authUser?.role,
          profileUrl: authUser?.profileUrl,
        };
        setLoginUser(updatedUser);
      } else {
        toast.error(response?.message);
      }
    } catch (error) {
      const message = handleConsoleError(error);
      toast.error(error?.message || message);
    }
  };

  const handleShowModal = () => {
    setShowModal(true);
    reset(userData);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    reset(UserProfileModel);
  };

    const handleEmailShowModal = () => {
    setShowEmailModal(true);
   
  };

  const handleEmailCloseModal = () => {
    setShowEmailModal(false);
   
  };

  const setSelectedCountry = (value) => {
    if (value) {
      setSelectedCountryId(value);
    } else {
      setSelectedCountryId("");
      setSelectedStateId("");
    }
  };
  const setSelectedState = (value) => {
    if (value) {
      setSelectedStateId(value);
    } else {
      setSelectedStateId("");
    }
  };
  const getUserProfile = async () => {
    try {
      props.application.setLoading(true);
      const userId = loginUser?.id;
      const user = await getUserProfileById(userId);
      const stateList = await getStateList();
      const countryList = await getCountryList();

      if (user?.isSuccess) {
        user.data.video = "";

        if (user && user.data && user.data.birthday) {
          user.data.birthday = user.data?.birthday.split("T")[0];
        }
        const userMappedData = { ...UserProfileModel, ...user?.data };
        reset(userMappedData);
        setUserData(userMappedData);

        setStateList(stateList?.data || []);
        setCountryList(countryList?.data || []);

         const authUser = getLoginUser();
        const updatedUser = {
          id: authUser?.id,
          firstName: user?.data?.firstName,
          lastName: user?.data?.lastName,
          email: user?.data?.email,
          role: authUser?.role,
          profileUrl: authUser?.profileUrl,
        };
        setLoginUser(updatedUser);
      } else {
        reset(UserProfileModel);
        setStateList(stateList?.data || []);
        setCountryList(countryList?.data || []);
      }

      if (user.data.countryId) {
        setSelectedCountryId(user?.data?.countryId);
        setIsCountrySelected(true);
        setUserData((prev) => ({
          ...prev,
          country: countryList.data.find(
            (country) => country?.id === user?.data?.countryId
          ),
        }));
      }
      if (user?.data?.stateId) {
        setSelectedStateId(user?.data?.stateId);
        setUserData((prev) => ({
          ...prev,
          state: stateList.data.find((state) => state?.id === user?.data?.stateId),
        }));
      }
      props.application.setLoading(false);
    } catch (error) {
      props.application.setLoading(false);
     const message= handleConsoleError(error);
      toast.error(error?.message|| message);
    }
  };

  useEffect(() => {
    getUserProfile();
  }, []);

  const filteredStates = stateList.filter(
    (state) => state?.countryId === selectedCountryId
  );

  const openProfileModal = () => {
    setPreviewImageURL(userData?.profilePicture && userData?.profilePictureUrl);
    openModal();
  };

  return (
    <React.Fragment>
      <Modal isOpen={isModalOpen} onClose={closeModal}>
        <ImageUpload
          imageURL={previewImageURL}
          onUpload={handleImageUpload}
          maxSize={4 * 1024 * 1024}
          validTypes={["image/png", "image/gif", "image/jpeg"]}
        ></ImageUpload>
      </Modal>
      <section className="bread-head">
        <div className="container">
          <div className="row bread-head3">
            <div className="col-lg-12 col-sm-12">
              <div className="bread-head2">
                <h5>
                  <Link to={routes.ACCOUNT_DASHBOARD}>Account</Link>{" "}
                  <i className="fa-solid fa-chevron-right"></i> Personal info
                </h5>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="edit-form">
        <div className="container">
          <div className="row edit22">
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="edit-form2-img">
                <div className="edit-form2-img1">
                  {/* <img src="assets/images/user-test.png" alt="" /> */}
                  <Avatar
                    imageUrl={
                      userData?.profilePicture && userData?.profilePictureUrl
                    }
                    altText={
                      userData?.firstName && userData?.lastName
                        ? userData?.firstName?.toUpperCase()[0] +
                          "" +
                          userData?.lastName?.toUpperCase()[0]
                        : loginUser?.firstName?.toUpperCase()[0] +
                          "" +
                          loginUser?.lastName?.toUpperCase()[0]
                    }
                    size={80}
                    borderColor={globalConstant.COLOR_PINK}
                    backgroundColor={globalConstant.COLOR_LITE}
                  />
                  {/* {userData.profilePictureUrl ? (
                    <ImagePreview
                      src={userData.profilePictureUrl}
                      width="100px"
                      height="100px"
                      style={{
                        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                        BorderAll: "dark",
                        boxshadow: "green",
                      }}
                    />
                  ) : (
                    <div
                      onClick={openModal}
                      aria-label="John"
                      className="relative text-white text-center rounded-big user-select-none"
                      style={{
                        backgroundColor: "#767676",
                        fontSize: "50px",
                        lineHeight: "100px",
                        textTransform: "uppercase",
                      }}
                    >
                      {userData.firstName.toUpperCase()[0]}
                      {userData.lastName.toUpperCase()[0]}
                    </div>
                  )} */}
                </div>
                <div className="edit-form2-text2">
                  <h3>
                    {" "}
                    {userData?.firstName} {userData?.lastName}
                  </h3>
                </div>
              </div>
            </div>

            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="edit-text3">
                <h3>
                  <span onClick={openProfileModal}>
                    <i className="fa-solid fa-pen-to-square"></i> edit photo
                  </span>
                </h3>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="form-edit55">
        <div className="container edit33">
          <div className="row">
            <div className="col-lg-8 col-md-8 col-sm-12">
              <div className="row">
                <div className="edit-label1 edit-last1 col-md-4 col-sm-12">
                  <h4>First name </h4>
                </div>
                <div className="edit-label11 edit-last2 col-md-8 col-sm-12">
                  <h5>{userData?.firstName}</h5>
                </div>
              </div>
              <div className="row">
                <div className="edit-label1 edit-last1 col-md-4 col-sm-12">
                  <h4>Last name</h4>
                </div>
                <div className="edit-label11 edit-last2 col-md-8 col-sm-12">
                  <h5>{userData?.lastName}</h5>
                </div>
              </div>
              <div className="row">
                <div className="edit-label1 edit-last1 col-md-4 col-sm-12">
                  <h4>Preferred name</h4>
                </div>
                <div className="edit-label11 edit-last2 col-md-8 col-sm-12">
                  <h5>{userData?.prefferedName}</h5>
                </div>
              </div>
              <div className="row">
                <div className="edit-label1 edit-last1 col-md-4 col-sm-12">
                  <h4>Email</h4>
                </div>
                <div className="edit-label11 edit-last2 col-md-8 col-sm-12">
                  <h5>{userData?.email}</h5>
                </div>
              </div>
              <div className="row">
                <div className="edit-label1 edit-last1 col-md-4 col-sm-12">
                  <h4>Phone</h4>
                </div>
                <div className="edit-label11 edit-last2 col-md-8 col-sm-12">
                  <h5>{userData?.phone}</h5>
                </div>
              </div>
              <div className="row">
                <div className="edit-label1 edit-last1 col-md-4 col-sm-12">
                  <h4>Birthday</h4>
                </div>
                <div className="edit-label11 edit-last2 col-md-8 col-sm-12">
                  <h5>{formatDateENGB(userData?.birthday)}</h5>
                </div>
              </div>
              <div className="row">
                <div className="edit-label1 edit-last1 col-md-4 col-sm-12">
                  <h4>Gender</h4>
                </div>
                <div className="edit-label11 edit-last2 col-md-8 col-sm-12">
                  <h5>{userData?.gender}</h5>
                </div>
              </div>
              <div className="row">
                <div className="edit-label1 edit-last1 col-md-4 col-sm-12">
                  <h4>Address</h4>
                </div>
                <div className="edit-label11 edit-last2 col-md-8 col-sm-12">
                  <h5>
                    {userData?.streetAddress || ""}
                    {userData?.city ? `, ${userData?.city}` : ""}
                    {userData?.state?.stateName
                      ? `, ${userData?.state?.stateName}`
                      : ""}
                    {userData?.postalCode ? ` ${userData?.postalCode}` : ""}
                    {userData?.country?.countryName
                      ? `, ${userData.country.countryName}`
                      : ""}{" "}
                  </h5>
                </div>
              </div>
              <div className="row">
                <div className="edit-label1 edit-last1 col-md-4 col-sm-12">
                  <h4>Description</h4>
                </div>
                {/* <div className="edit-label11 edit-last2">
                  <h5>{userData.description}</h5>
                </div> */}
                <div className="edit-label11 edit-last2 col-md-8 col-sm-12">
                  <h5
                    style={{
                      height: 150,
                    }}
                  >
                    {" "}
                    <p
                      style={{
                        width: "100%", // Make the textarea take up the full width of its container
                        height: "120px", // Set the height of the textarea
                        overflowY: "auto", // Enable vertical scrolling when content overflows
                        resize: "none", // Allow the user to resize the textarea
                      }}
                    >
                      {userData?.description}
                    </p>
                  </h5>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-12">
              <div className="test-edit">
                <h6>
                  <span onClick={handleShowModal}>
                    <i className="fa-solid fa-pen-to-square"></i> edit
                  </span>
                </h6>
                <h6>
                      <span onClick={handleEmailShowModal} >
                        <i className="fa-solid fa-envelope"></i> Change Email
                      </span>
                    </h6>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <section className="form-edit55 login">
        <div className="container edit33">
          <h2>Change Password</h2>
          <div className="row">
            <div className="col-lg-6 col-sm-12">
              <div className="edit-label">
                <div className="edit-label1">
                  <h4>Password</h4>
                </div>
                <div className="edit-label11">
                  <h5>Last changed 20 days ago</h5>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-sm-12">
              <div className="test-edit">
                <h6>
                  <i className="fa-solid fa-pen-to-square"></i> update
                </h6>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      <CommonModal
        show={showModal}
        onHide={handleCloseModal}
        title={"Update Personal Information"}
        size="lg"
        footerActions={[
          { label: "Close", variant: "secondary", onClick: handleCloseModal },
          {
            label: "Update",
            type: "button",
            onClick: handleSubmit(onSubmit),
          },
        ]}
      >
        <Form onSubmit={handleSubmit(onSubmit)}>
           <Form.Control            
              type="hidden"
              name="email"
              value={userData?.email}
            />
          <Form.Group controlId="firstName">
            <Form.Label>First Name</Form.Label>
            {/* <Form.Control
              maxLength={20}
              type="text"
              {...register("firstName")}
              defaultValue={userData.firstName}
            />
            {errors.firstName && (
              <span className="text-danger">{errors.firstName.message}</span>
            )} */}
            <Form.Control
              maxLength={20}
              type="text"
              {...register("firstName")}
              defaultValue={userData?.firstName}
              onChange={(e) => {
                const value = e.target.value;
                setValue(
                  "firstName",
                  value?.charAt(0)?.toUpperCase() + value?.slice(1)
                );
              }}
            />
            {errors.firstName && (
              <span className="text-danger">{errors.firstName?.message}</span>
            )}
          </Form.Group>
          <Form.Group controlId="lastName">
            <Form.Label>Last Name</Form.Label>
            <Form.Control
              maxLength={20}
              type="text"
              {...register("lastName")}
              onChange={(e) => {
                const value = e.target.value;
                setValue(
                  "lastName",
                  value?.charAt(0)?.toUpperCase() + value?.slice(1)
                );
              }}
              defaultValue={userData?.lastName}
            />
            {errors.lastName && (
              <span className="text-danger">{errors.lastName?.message}</span>
            )}
          </Form.Group>
          <Form.Group controlId="prefferedName">
            <Form.Label>Preferred Name</Form.Label>
            <Form.Control
              maxLength={50}
              type="text"
              {...register("prefferedName")}
              onChange={(e) => {
                const value = e.target.value;
                setValue(
                  "prefferedName",
                  value?.charAt(0)?.toUpperCase() + value?.slice(1)
                );
              }}
              defaultValue={userData?.prefferedName}
            />
            {errors.preferredName && (
              <span className="text-danger">
                {errors.preferredName.message}
              </span>
            )}
          </Form.Group>
          {/* <Form.Group controlId="email">
            <Form.Label>Email</Form.Label>
            <Form.Control
              maxLength={80}
              type="email"
              {...register("email", {
                pattern: {
                  value: globalConstant.emailRegex,
                  message: "Invalid Email",
                },
              })}
              onChange={(e) => {
                const value = e.target.value;
                setValue(
                  "email",
                  value?.charAt(0)?.toUpperCase() + value?.slice(1)
                );
              }}
              defaultValue={userData?.email}
            />
            {errors.email && (
              <span className="text-danger">{errors.email?.message}</span>
            )}
          </Form.Group> */}
          <Form.Group controlId="phone">
            <Form.Label>
              Phone Number <i className="text-danger"></i>
            </Form.Label>
            <Form.Control
              maxLength={15}
              type="text"
              {...register("phone", {
                required: "Phone number is required",
                pattern: {
                  value: /^[0-9]\d{8,14}$/,
                  message: "Invalid phone number",
                },
              })}
              defaultValue={userData?.phone}
            />
            {errors.phone && (
              <span className="text-danger">{errors.phone?.message}</span>
            )}
          </Form.Group>
          <Form.Group controlId="birthday">
            <Form.Label>Birthday</Form.Label>
            <Form.Control
              type="date"
              {...register("birthday")}
              defaultValue={userData?.birthday}
              max={new Date().toISOString().split("T")[0]}
            />
            {errors.birthday && (
              <span className="text-danger">{errors.birthday?.message}</span>
            )}
          </Form.Group>
          <Form.Group controlId="gender">
            <Form.Label>Gender</Form.Label>
            <Form.Select
              //as="select"
              {...register("gender")}
              defaultValue={userData?.gender}
            >
              <option value="">Select Gender</option>
              <option value="M">Male</option>
              <option value="F">Female</option>
              <option value="O">Other</option>
            </Form.Select>
            {errors.gender && (
              <span className="text-danger">{errors.gender?.message}</span>
            )}
          </Form.Group>
          <Form.Group controlId="country">
            <Form.Label>
              State<span className="text-danger">*</span>
            </Form.Label>
            <Form.Select
              // as="select"
              {...register("countryId", {
                required: "State is required",
              })}
              value={selectedCountryId}
              onChange={(e) => {
                const countryId = e.target.value;
                setSelectedCountry(countryId);
                setIsCountrySelected(countryId !== "");
              }}
            >
              <option value="">Select State</option>
              {countryList.map((country) => (
                <option key={country?.id} value={country?.id}>
                  {country?.countryName}
                </option>
              ))}
            </Form.Select>
            {errors.countryId && (
              <span className="text-danger">{errors.countryId?.message}</span>
            )}
          </Form.Group>
          <Form.Group controlId="streetAddress">
            <Form.Label>Street Address</Form.Label>
            <Form.Control
              type="text"
              {...register("streetAddress", {
                required: isCountrySelected
                  ? "Street Address is required"
                  : false,
              })}
              onChange={(e) => {
                const value = e.target.value;
                setValue(
                  "streetAddress",
                  value?.charAt(0)?.toUpperCase() + value?.slice(1)
                );
              }}
              defaultValue={userData?.streetAddress}
            />
            {errors.streetAddress && (
              <span className="text-danger">
                {errors.streetAddress?.message}
              </span>
            )}
          </Form.Group>
          <Form.Group controlId="city">
            <Form.Label>City</Form.Label>
            <Form.Control
              type="text"
              {...register("city", {
                required: isCountrySelected ? "City is required" : false,
              })}
              onChange={(e) => {
                const value = e.target.value;
                setValue(
                  "city",
                  value?.charAt(0)?.toUpperCase() + value?.slice(1)
                );
              }}
              defaultValue={userData?.city}
            />
            {errors.city && (
              <span className="text-danger">{errors.city?.message}</span>
            )}
          </Form.Group>
          <Form.Group controlId="state">
            <Form.Label>Country</Form.Label>
            <Form.Select
              // as="select"
              {...register("stateId", {
                required: isCountrySelected ? "Country is required" : false,
              })}
              value={selectedStateId}
              onChange={(e) => {
                setSelectedStateId(e.target.value);
                setSelectedState(e.target.value);
              }}
            >
              <option value="">Select Country</option>
              {filteredStates.map((state) => (
                <option key={state?.id} value={state?.id}>
                  {state?.stateName}
                </option>
              ))}
            </Form.Select>
            {errors.stateId && (
              <span className="text-danger">{errors.stateId?.message}</span>
            )}
          </Form.Group>
          <Form.Group controlId="postalCode">
            <Form.Label>Zip Postal Code</Form.Label>
            <Form.Control
              type="text"
              {...register("postalCode", {
                required: isCountrySelected ? "Postal Code is required" : false,
                pattern: {
                  value: /^[A-Za-z0-9\s-]{3,10}$/,
                  message: "Invalid Postal Code",
                },
              })}
              onChange={(e) => {
                const value = e.target.value;
                setValue(
                  "postalCode",
                  value.charAt(0).toUpperCase() + value.slice(1)
                );
              }}
              defaultValue={userData?.postalCode}
            />
            {errors.postalCode && (
              <span className="text-danger">{errors.postalCode?.message}</span>
            )}
          </Form.Group>
          <Form.Group controlId="description">
            <Form.Label>Description</Form.Label>
            <Form.Control
              as="textarea"
              maxLength={500}
              rows={3}
              {...register("description")}
            />
            {errors.description && (
              <span className="text-danger">{errors.description?.message}</span>
            )}
          </Form.Group>          
        </Form>
      </CommonModal>

            <CommonModal
        show={showEmailModal}
        onHide={handleEmailCloseModal}
        title={"Email Change Request"}
        size="lg"
        footerActions={[
          { label: "Close", variant: "secondary", onClick: handleEmailCloseModal },
          {
            label: "Submit",
            type: "button",
            onClick: onEmailChangeSubmit,
          },
        ]}
      >
   <UpdateEmail  setSubmitHandler={setSubmitHandler} props={props}  onEmailChangeSuccess={onEmailChangeSuccess} ></UpdateEmail>
     
      </CommonModal>
    </React.Fragment>
  );
};
export default injectModels(["application"])(PersonalInfo);
